export default __webpack_public_path__ + "af8f28d722c20a9ebbe73fdfbe2bca77.png";